import type { NextPage } from "next";
import type { IAuthLayout } from "./customer-auth-layout/interfaces";

export type CustomerLayoutProps = Omit<IAuthLayout, "children">;

export type PageLayoutConfig =
  | { type: "none" }
  | { type: "admin" }
  | { type: "customer"; props?: CustomerLayoutProps };

export type NextPageWithLayout<P = Record<string, unknown>, IP = P> = NextPage<
  P,
  IP
> & {
  pageLayout?: PageLayoutConfig | (() => PageLayoutConfig);
};

export const resolvePageLayout = (
  Component: NextPageWithLayout
): PageLayoutConfig => {
  const layout = Component.pageLayout;
  if (!layout) {
    return { type: "none" };
  }
  return typeof layout === "function" ? layout() : layout;
};
